import React, {FC} from 'react'
import {Trans, useTranslation} from 'react-i18next'

import CloseIcon from '@mui/icons-material/Close'
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Theme,
  Typography,
} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

import {SACTIONED_COUNTRIES} from '@progyny/utils/constants'

type CountryGuidelineDialogProps = {
  showDialog: boolean
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>
}

const useStyles = makeStyles()((theme: Theme) => ({
  dialogContent: {
    color: theme.palette.text.primary,
    fontSize: 18,
    fontWeight: 400,
    marginBottom: 20,
  },
}))

const CountryGuidelineDialog: FC<CountryGuidelineDialogProps> = (
  props: CountryGuidelineDialogProps
) => {
  const {showDialog, setShowDialog} = props
  const {t} = useTranslation()
  const {classes} = useStyles()

  return (
    <Dialog
      open={showDialog}
      onClose={() => setShowDialog(false)}
      aria-labelledby='country-specific-description'
      fullWidth
      maxWidth='md'
    >
      <DialogTitle textAlign={'center'} id='alert-dialog-title'>
        {t('budget_reimbursement_helpers_country_guideline_dialog_please_note')}
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={() => setShowDialog(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText
          id='alert-dialog-desc-1'
          className={classes.dialogContent}
        >
          <Trans i18nKey='budget_reimbursement_helpers_country_guideline_dialog_due_to_current_i' />
        </DialogContentText>
        <DialogContentText
          id='alert-dialog-desc-2'
          className={classes.dialogContent}
        >
          <Trans i18nKey='budget_reimbursement_helpers_country_guideline_dialog_for_following_li' />
        </DialogContentText>
        <DialogContentText
          id='alert-dialog-desc-3'
          className={classes.dialogContent}
        >
          <Trans i18nKey='budget_reimbursement_helpers_country_guideline_dialog_for_following_li_2' />
        </DialogContentText>
        <Grid container spacing={1}>
          {SACTIONED_COUNTRIES.map((country, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Typography>{t(country)}</Typography>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default CountryGuidelineDialog
